import { useSelector } from 'src/store/react';
import { selectLocationQuery } from 'src/store/selectors';

export const useHasRecsQueryString = (): boolean =>
  useSelector(selectLocationQuery)?.ref === 'recs';
